export default __webpack_public_path__ + "static/media/result.35dc8b10.svg";